// components/ModalAddEvent.jsx
import { useState } from "react";
import Swal from "sweetalert2";

export default function ModalAddEvent({ isOpen, onClose, onAdded }) {
  const [eventName, setEventName] = useState("");
  const [eventClient, setEventClient] = useState("");
  const [eventPlace, setEventPlace] = useState("");
  const [eventStatus, setEventStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!eventName.trim()) return;

    const data = {
      name: eventName,
      client: eventClient,
      place: eventPlace,
      status: eventStatus ? 1 : 0, // pastikan status berupa angka
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/events/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Gagal menyimpan event");
      }

      const resData = await response.json();

      if (resData && resData.id) {
        onAdded(resData); 
      }
        Swal.fire('Berhasil', 'Event berhasil ditambahkan.', 'success');
        setEventName("");
        setEventClient("");
        setEventPlace("");
        setEventStatus("");
        onClose();
    } catch (err) {
      console.error("Error:", err.message);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-96">
        <h2 className="text-lg font-semibold mb-4">Tambah Event </h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            className="w-full border p-2 rounded mb-4"
            placeholder="Nama Event"
            value={eventName}
            onChange={(e) => setEventName(e.target.value)}
          />
          <input
            type="text"
            className="w-full border p-2 rounded mb-4"
            placeholder="Nama Perusahaan/Client"
            value={eventClient}
            onChange={(e) => setEventClient(e.target.value)}
          />
          <input
            type="text"
            className="w-full border p-2 rounded mb-4"
            placeholder="Tempat Event"
            value={eventPlace}
            onChange={(e) => setEventPlace(e.target.value)}
          />
          <button
            type="button"
            onClick={() => setEventStatus(!eventStatus)}
            className={`w-14 h-7 flex items-center rounded-full p-1 transition-colors duration-300 ${
              eventStatus ? "bg-green-500" : "bg-gray-300"
            }`}
          >
            <div
              className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 ${
                eventStatus ? "translate-x-7" : "translate-x-0"
              }`}
            />
          </button>
          <span className="">{eventStatus ? "Status: Aktif" : "Status: Tidak Aktif"}</span>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={onClose} className="text-gray-500">Batal</button>
            <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
              Simpan
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
